<div class="posts-sidebar">
    <div class="widget latest-post-widget wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="1200ms">
        <h4 class="sidebar-widget-title">Latest News</h4>
        <div class="popular-posts-wrapper">
            <!-- Data -->
            <div class="popular-posts-item" *ngFor="let item of getRecentPost()">
                <div class="popular-posts-thumbnail">
                    <a routerLink="/blog-details/{{item.id}}">
                        <img [src]="item.image[0]" [alt]="item.title">
                    </a>
                </div>
                <div class="popular-posts-item-content">
                    <h5 class="popular-posts-title"><a routerLink="/blog-details/{{item.id}}">{{item.title |
                            slice:0:40}}...</a></h5>
                    <a routerLink="/blog-details/{{item.id}}" class="posts-date"><i class="far fa-calendar-alt"></i>
                        {{item.postdate}}</a>
                </div>
            </div>
            <!-- Data -->
        </div>
    </div>
<!--    <div class="widget widget-testimonial wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="1200ms">-->
<!--        <app-single-testimonials></app-single-testimonials>-->
<!--    </div>-->
<!--    <div class="widget widget-tag-cloud wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1200ms">-->
<!--        <h4 class="sidebar-widget-title">Popular Tags</h4>-->
<!--        &lt;!&ndash; Data &ndash;&gt;-->
<!--        <a routerLink="/blog/tag/{{item.id}}" *ngFor="let item of tags">{{item.title}}</a>-->
<!--        &lt;!&ndash; Data &ndash;&gt;-->
<!--    </div>-->
</div>
